import { AttributeModel } from "../main/dynamic/model/attribute.model"

export class UserModel {
    id: string
    name: string
    userName: string
    email: string
    inactive?: boolean
    roles?: string[]
    attributes?: AttributeModel[]
    hasValidPassword: boolean
    tenantId?: string
    workspaceId?: string
    userType: string
    defaultProcessId: string

    constructor() {
        this.attributes = []
    }
}